<script setup lang="ts" generic="T extends string">
import type { TabMenuItem } from '~/constants/tab'
import { NuxtLink } from '#components'
import { TabsList, TabsRoot, TabsTrigger } from 'reka-ui'

const props = defineProps<{
  options: TabMenuItem<T>[]
  containsLinks?: boolean
}>()

const model = defineModel<TabMenuItem<T>>()

const modelValue = computed(() => model.value?.value)

function setActiveTab(value: string) {
  model.value = props.options.find(tab => tab.value === value)
}
</script>

<template>
  <TabsRoot :model-value="modelValue" @update:model-value="setActiveTab">
    <TabsList class="flex overflow-x-auto gap-2xs no-scrollbar">
      <TabsTrigger
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        class="shrink-0 text-small rounded-lg transition-colors hover:bg-surface-hover data-[state=active]:bg-surface-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-blurple-300"
      >
        <component :is="containsLinks ? NuxtLink : 'div'" :to="containsLinks ? { name: option.value } : undefined" class="flex px-s py-2.5xs text-small items-center gap-2xs no-underline">
          <Icon v-if="option.icon" :icon="option.icon" class="hidden sm:flex text-[currentColor]" />
          {{ option.label }}
        </component>
      </TabsTrigger>
    </TabsList>
  </TabsRoot>
</template>
